import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { tap } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { Duel } from './duel.service';
import { ToastService } from './toast.service';

export interface Notification {
	_id?: string;
	notificationId?: string;
	description?: string;
	recipient?: string;
	type?: string;
	status?: string;
	readAt?: string;
	duel?: Duel;
}

@Injectable({
	providedIn: 'root',
})
export class NotificationService {
	private restServerUrl: string;
	private notifications = new BehaviorSubject<Notification[]>([]);
	notifications$ = this.notifications.asObservable();
	private notificationBadgeCount = new BehaviorSubject<number>(0);
	notificationBadgeCount$ = this.notificationBadgeCount.asObservable();

	constructor(
		private http: HttpClient,
		private toastService: ToastService,
	) {
		const protocol = environment.ssl ? 'https://' : 'http://';
		this.restServerUrl = protocol + environment.restServer + ':' + environment.restServerPort;
	}

	getNotificationList() {
		this.http.get<Notification[]>(this.restServerUrl + '/api/notification/list').subscribe({
			next: notifications => {
				this.notifications.next(notifications);
				const unreadBadgeCount = notifications.filter(note => note?.readAt === null).length;
				this.notificationBadgeCount.next(unreadBadgeCount);
			},
			error: () => {
				this.toastService.showToastOnError('Keine Verbindung zum Server');
			},
		});
	}

	updateNotification(data: { notificationId: string; status: string }) {
		const notifacationData: Notification = {
			notificationId: data.notificationId,
			status: data.status,
		};
		return this.http.post<Notification>(this.restServerUrl + '/api/notification/update', notifacationData).pipe(
			tap(() => {
				this.notificationBadgeCount.next(this.notificationBadgeCount.value - 1);
			}),
		);
	}
}
